import gql from 'graphql-tag';

export const assignTaskFragment = gql`
fragment AssignTask_result on Task {
  id
  auditor {
    id
    name
  }
}
`;

export const taskFragment = gql`
fragment ListTaskPageTask on Task {
  id
  auditor {
    id
    name
  }
  clientSummary {
    client {
      id
      name
    }
    count
  }
  date
  note
  status
  outlet {
    id
    name
    retailer {
      id
      name
      logo {
        id
        url
      }
    }
  }
  priority
  productSummary {
    category {
      id
      name
    }
    count
  }
  totalEntries
}
`;

export const listTaskQL = gql`
  query {
    tasks: listTask {
      id
      ...ListTaskPageTask
    }
  }
  ${taskFragment}
`;

